/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enddatetimerequired3Inputs */

const en_enddatetimerequired3 = /** @type {(inputs: Enddatetimerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date and time is required`)
};

const de_enddatetimerequired3 = /** @type {(inputs: Enddatetimerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum und -zeit ist erforderlich`)
};

/**
* | output |
* | --- |
* | "End date and time is required" |
*
* @param {Enddatetimerequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const enddatetimerequired3 = /** @type {((inputs?: Enddatetimerequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enddatetimerequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enddatetimerequired3(inputs)
	return de_enddatetimerequired3(inputs)
});
export { enddatetimerequired3 as "endDateTimeRequired" }